import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import KnowledgeAssetArticleAppResource from './KnowledgeAssetArticleAppResource';
import KnowledgeAssetTagAppResource from './KnowledgeAssetTagAppResource';
import KnowledgeBaseAppResource from './KnowledgeBaseAppResource';
import ResourceStageTypeAppResource from './ResourceStageTypeAppResource';
import StageTypeAppResource from './StageTypeAppResource';
import WorkspaceTypeAppResource from './WorkspaceTypeAppResource';
import OrganizationAppResource from "./OrganizationAppResource";
import ReferralPartnerTypeAppResource from './ReferralPartnerTypeAppResource';
import BusinessProfileServiceAppResource from './BusinessProfileServiceAppResource';
import FormsetAppResource from "./FormsetAppResource";
import LuFormCategoryAppResource from "./LuFormCategoryAppResource";
import LuStateAppResource from "./LuStateAppResource";
import ServiceProviderTypeAppResource
    from "@milestoneslabs/milestones-core-js/src/AppResources/ServiceProviderTypeAppResource";

export const TYPE = {
    KNOWLEDGE_ASSET: 1,
    KNOWLEDGE_ASSET_TAG: 2,
    EXTERNAL_LINK: 3,
    INTERNAL_APP: 4,
    REFERRAL_PARTNER: 7,
    FORMSET: 8,
};

class ResourceAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'resource';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'resources';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'internalName',
            'projectLabel',
            'description',
            'iconUuid',
            'isActive',
            'isSystem',
            'requiredIntegration',
            'externalWebsiteName',
            'externalWebsiteUrl',
            'icon',
            'knowledgeBaseUuid',
            'knowledgeAssetArticleUuid',
            'stageTypes',
            'resourceStageTypes',
            'workspaceTypes',
            'knowledgeBase',
            'knowledgeAsset',
            'type',
            'knowledgeAssetTags',
            'workspaceTypes',
            'stageTypes',
            'resourceStageTypes',
            'organizationUuid',
            'organization',
            'applicationUrl',
            'referralPartnerType',
            'referralPartnerTypeUuid',
            'businessProfileServiceUuid',
            'businessProfileService',
            'serviceProviderTypeUuid',
            'formsetUuid',
            'formset',
            'formsetCategoryId',
            'formsetCategory',
            'formsetStateId',
            'formsetState',
            'formsetIssuedByAnAuthority',
            'serviceProviderType',
            'isMultiSelect',
            'isRemovable',
            'removedByMembers',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            icon: FileAppResource,
            stageTypes: StageTypeAppResource,
            resourceStageTypes: ResourceStageTypeAppResource,
            workspaceTypes: WorkspaceTypeAppResource,
            knowledgeBase: KnowledgeBaseAppResource,
            knowledgeAsset: KnowledgeAssetArticleAppResource,
            knowledgeAssetTags: KnowledgeAssetTagAppResource,
            externalWebsiteLogo: FileAppResource,
            organization: OrganizationAppResource,
            referralPartnerType: ReferralPartnerTypeAppResource,
            businessProfileService: BusinessProfileServiceAppResource,
            formset: FormsetAppResource,
            formsetCategory: LuFormCategoryAppResource,
            formsetState: LuStateAppResource,
            serviceProviderType: ServiceProviderTypeAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            serviceProviderType: 'service_provider_type_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            internalName: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            projectLabel: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            iconUuid: {
                type: 'string',
                presence: true,
            },
            description: {
                type: 'string',
            },
            isActive: {
                type: 'boolean',
            },
            isSystem: {
                type: 'boolean',
            },
            requiredIntegration: {
                type: 'boolean',
            },
            type: {
                presence: true,
                numericality: true,
            },
            knowledgeBaseUuid: {
                type: 'string',
            },
            knowledgeAssetArticleUuid: {
                type: 'string',
            },
            externalWebsiteName: {
                type: 'string',
            },
            externalWebsiteUrl: {
                type: 'string',
            },
            organizationUuid: {
                type: 'string',
                presence: true
            },
            workspaceTypes: {
                type: 'array'
            },
            stageTypes: {
                type: 'array'
            },
            resourceStageTypes: {
                type: 'array'
            },
            applicationUrl: {
                emptyUrl: true
            },
            referralPartnerTypeUuid: {
                type: 'string'
            },
            businessProfileServiceUuid: {
                type: 'string'
            },
            serviceProviderTypeUuid: {
                type: 'string'
            },
            formsetUuid: {
                type: 'string'
            },
            formsetCategoryId: {
                type: 'number'
            },
            formsetStateId: {
                type: 'number'
            },
            formsetIssuedByAnAuthority: {
                type: 'boolean'
            },
            isMultiSelect: {
                type: 'boolean'
            },
            isRemovable: {
                type: 'boolean'
            },
            removedByMembers: {
                type: 'array'
            },
        };
    }

}

export default ResourceAppResource;
